import apiClient from './index'
import type { Cabinet, CabinetCreate, CabinetUpdate } from '@/types'
import type { ListQueryParams } from './types'

const BASE_URL = '/ssp/cabinets'

export const cabinetsApi = {
  getAll: (params?: ListQueryParams) => apiClient.get<Cabinet[] | { items?: Cabinet[], results?: Cabinet[], data?: Cabinet[] }>(BASE_URL, { params })
    .then(res => {
      const data = res.data as any
      console.log('[cabinetsApi] Raw response:', data, 'IsArray:', Array.isArray(data))
      if (Array.isArray(data)) {
        return data
      } else if (data && typeof data === 'object' && data.items) {
        return data.items
      } else if (data && typeof data === 'object' && data.results) {
        return data.results
      } else if (data && typeof data === 'object' && data.data) {
        return data.data
      }
      return []
    }),
  getById: (id: number) => apiClient.get<Cabinet>(`${BASE_URL}/${id}`).then(res => res.data),
  create: (data: CabinetCreate) => apiClient.post<Cabinet>(BASE_URL, data).then(res => res.data),
  update: (id: number, data: CabinetUpdate) => apiClient.put<Cabinet>(`${BASE_URL}/${id}`, data).then(res => res.data),
  delete: (id: number) => apiClient.delete<Cabinet>(`${BASE_URL}/${id}`).then(res => res.data),
}
